module.exports = __webpack_public_path__ + "img/Cards.ae838231.png";